import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Switch,
  FormControlLabel
} from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import AuthService from '../services/auth.service';

interface ConsentModalProps {
  open: boolean;
  onClose: () => void;
}

const ConsentModal: React.FC<ConsentModalProps> = ({ open, onClose }) => {
  const { currentUser, updateUser } = useAuth();
  const [consentAccepted, setConsentAccepted] = useState(currentUser?.consent_accepted || false);

  const privacyLink = (
    <a href="https://www.csiro.au/Privacy" target="_blank" rel="noopener noreferrer">
      https://www.csiro.au/Privacy
    </a>
  );

  const handleSave = async () => {
    if (!currentUser) return;

    try {
      await AuthService.updateConsent(currentUser.email, consentAccepted);
      updateUser({
        ...currentUser,
        consent_accepted: consentAccepted,
        consent_viewed: true,
      });
      onClose();
    } catch (error) {
      console.error('Error updating consent:', error);
    }
  };

  return (
    <Dialog open={open} onClose={() => {}} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography variant="h6" component="div">
          Data Collection Consent
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mb: 2 }}>
          <Typography variant="body1" paragraph>
            We have updated our Data Collection Process. Details of this are available at {privacyLink}.
          </Typography>
          <Typography variant="body2" color="text.secondary" paragraph>
            You can review and edit your preferences at any time in your account settings.
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 3 }}>
          <Typography variant="body1">
            Allow data collection for EcoActionAI services:
          </Typography>
          <FormControlLabel
            control={
              <Switch
                checked={consentAccepted}
                onChange={(e) => setConsentAccepted(e.target.checked)}
                color="primary"
              />
            }
            label=""
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleSave} variant="contained" color="primary">
          Save Preferences
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConsentModal;